import { createSlice } from "@reduxjs/toolkit";

import { Languages } from "src/translations";

export type LanguageState = {
    currentLang: Languages;
};

const initialState: LanguageState = {
    currentLang: Languages.en,
};

export const languageState = createSlice({
    name: "LanguageSlice",
    initialState,
    reducers: {
        changeLang: (state, action) => {
            return { ...state, currentLang: action.payload };
        },
    },
});

export const { changeLang } = languageState.actions;
